import { render, staticRenderFns } from "./FoodReceipt.vue?vue&type=template&id=146bc910&scoped=true"
import script from "./FoodReceipt.vue?vue&type=script&lang=js"
export * from "./FoodReceipt.vue?vue&type=script&lang=js"
import style0 from "./FoodReceipt.vue?vue&type=style&index=0&id=146bc910&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146bc910",
  null
  
)

export default component.exports